export const colors = {
  purple: '#2e374f',
  purpleLight: '#551a8b',
  blue: '#1481f7',
  blueLight: '#84BEFD',
  blueExtraLight: '#DDEDFE',
  blueDark: '#1862CB',
  black: '#000',
  red: '#f24c4c',
  redLight: '#F88E8D',
  redExtraLight: '#FDE0E0',
  redDark: '#C14539',
  green: '#1cd366',
  greenMedium: '#B8ECB7',
  greenLight: '#57FB9A',
  greenExtraLight: '#D1FDE3',
  greenDark: '#19A84B',
  greenOlive: '#d3d43b',
  greenOliveDark: '#bfc407',
  orange: '#f48427',
  orangeLight: '#FFB36D',
  orangeExtraLight: '#FFEAD7',
  orangeDark: '#C26E0D',
  grayExtraLight: '#F1F1F1',
  grayLight: '#E0E0E0',
  gray: '#BDBDBD',
  grayDark: '#757575',
  grayDeep: '#424242',
  grayDeep2: '#3d3d3d',
  grayItems: '#CCC',
  grayBodyDesktop: '#333',
  yellowLight: '#fffad5',
  white: '#fff',
  blackOpacity50: 'rgba(0, 0, 0, 0.5)',
};

export const fontSizes = {
  verySmall: '0.625rem', // 10px
  small: '0.75rem', // 12px
  mediumSmall: '0.875rem', // 14px
  normal: '1rem', // 16px
  big: '1.25rem', // 20px
};

export const fontWeight = {
  thinner: 100,
  thin: 300,
  normal: 400,
  bold: 500,
  bolder: 700,
};

export const media = {
  desktopMax: '1200px',
  desktop: '992px',
  tablet: '768px',
  mobile: '576px',
  mobileMin: '320px',
};

export const zIndexLevels = {
  lower: '0',
  low1: '1',
  low2: '2',
  low3: '3',
  low4: '4',
  low5: '5',
  medium1: '10',
  medium2: '20',
  medium3: '30',
  medium4: '40',
  medium5: '50',
  high1: '100',
  high2: '200',
  high3: '300',
  high4: '400',
  high5: '500',
  higher: '9999', // z-index cap
};

// Animation duration in seconds
export const animationDuration = {
  fast: 0.15,
};

export const themes = {
  homes: {
    primaryColor: colors.blue,
  },
  cars: {
    primaryColor: colors.red,
  },
  jobs: {
    primaryColor: colors.green,
  },
  products: {
    primaryColor: colors.orange,
  },
};

export default {
  global: {
    logo: colors.purple,
    font: colors.grayDark,
    borderRadius: '8px',
  },
  homes: {
    main: themes.homes.primaryColor,
  },
  cars: {
    main: themes.cars.primaryColor,
  },
  jobs: {
    main: themes.jobs.primaryColor,
  },
  products: {
    main: themes.products.primaryColor,
  },
  forms: {
    inputs: {
      borderColor: colors.grayLight,
      errorBorderColor: colors.red,
      placeholderColor: colors.gray,
    },
    buttons: {
      blue: {
        bg: colors.blue,
        border: colors.blue,
        color: '#FFFFFF',
      },
      orange: {
        bg: colors.orange,
        border: colors.orange,
        color: '#FFFFFF',
      },
      white: {
        bg: '#FFFFFF',
        border: colors.grayLight,
        color: colors.grayDark,
      },
      gray: {
        bg: colors.grayLight,
        border: colors.grayLight,
        color: colors.grayDark,
      },
      disabled: {
        bg: colors.grayLight,
        border: colors.grayLight,
        color: '#FFFFFF',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./app/themes/index.js